import IconCatch from '@/components/icons/icon-catch/icon-catch';
import { Flex, Text } from '@cmpsr/components';

export default function NonQuantifiableRiskFactor() {
  return (
    <Flex direction="column" gap="spacer-6">
      <Flex alignItems="center" gap="spacer-4">
        <IconCatch icon="risk-impact" size="l" borderRadius="10px" backgroundColor="background-page-03" />
        <Text variant="text-header-L">Risk impact</Text>
      </Flex>
      <Flex
        direction="column"
        gap="spacer-6"
        backgroundColor="background-light"
        borderRadius="radii-3"
        p="spacer-6"
        border="1px solid"
        borderColor="ui-element-divider"
      >
        <Text variant="text-body-regular">
          Research on this topic is ongoing. While research shows this lowers your cancer risk, we are unable to
          quantify exact risk impact.
        </Text>
      </Flex>
    </Flex>
  );
}
